import DefaultDialogController from 'utils/notifications/default-dialog-controller';

const mapStateToThis = ({ config }) => {
  const { locales } = config;

  return {
    locales,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'appFactory', '$timeout')
class FaqCategoryController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.onLanguageSelect(this.language);
    this.$timeout(() => {
      this.api.initializeForm.run(this.namespace, this.moduleName, this.form, !(this.category && this.category.id));
    });
  }

  $onDestroy() {
    this.unsubscribe();
  }

  submit() {
    this.form.$setSubmitted();
    if (this.form.$valid) {
      this.confirm(this.category);
    }
  }

  onLanguageSelect(locale) {
    this.appFactory.model[this.namespace][this.moduleName].language = locale;
  }
}

export default FaqCategoryController;



// WEBPACK FOOTER //
// ./src/modules/faq/components/faq-category-dialog/faq-category-dialog-controller.js